import { useCallback } from 'react';
import { VetterApprovalStatusEnum } from '@vette/data-access';
import { hooks, message } from '@vette/frontend-utils';

type VetterStatusData = {
  approvalStatus?: VetterApprovalStatusEnum | null;
  isProfileDataProvided?: boolean | null;
};

export const useVetterDisclaimer = () => {
  const { isVetter } = hooks.useRole();
  const showAwaitingNotification = (approvalPending: boolean) =>
    approvalPending &&
    isVetter &&
    message.info(
      'You are on the waitlist to become a Vetter. We will inform you once your account is approved.',
      0
    );

  return useCallback(
    (
      { approvalStatus, isProfileDataProvided }: VetterStatusData,
      initialMessage?: string,
      duration?: number
    ) => {
      const approvalPending =
        !!isProfileDataProvided && approvalStatus !== 'ACTIVE';

      message.destroy();

      initialMessage
        ? message.success({
            content: initialMessage,
            ...(duration && { duration }),
            onClose: () => showAwaitingNotification(approvalPending),
          })
        : showAwaitingNotification(approvalPending);
    },
    []
  );
};
